import { reportWarn } from '../owl'

export type QUEUE = Record<
  string,
  {
    callback: Function
  } | null
>

export default class LibLoader {
  public static guid(): string {
    const s = function () {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
    }
    return s() + s() + '-' + s() + '-' + s() + '-' + s() + '-' + s() + s() + s()
  }

  private queue: QUEUE
  private libLoaded: boolean
  private id: string
  private source: string
  private onload?: Function | undefined

  public constructor(id: string, source: string, onload?: Function | undefined) {
    this.id = id
    this.source = source
    this.queue = {}
    this.libLoaded = false
    this.onload = onload
    this.loadScript()
  }

  public loadScript() {
    if (!this.source) {
      this.libLoaded = true
      if (typeof this.onload === 'function') {
        this.onload()
      }
      this.handleCallback()
      return
    }
    const dom = document.getElementById(this.id)
    if (!dom) {
      const body = (document.getElementsByTagName('body') || [])[0]
      const script = document.createElement('script')
      script.src = this.source
      script.type = 'text/javascript'
      script.id = this.id
      body && body.appendChild(script)
      script.onload = () => {
        this.libLoaded = true
        if (typeof this.onload === 'function') {
          this.onload()
        }
        this.handleCallback()
      }
      script.onerror = () => {
        reportWarn(
          {
            name: '第三方库加载失败' + this.id,
            global: true,
          },
          { category: '3rd' },
        )
      }
    }
  }

  public push(callback: Function) {
    if (this.libLoaded) {
      callback()
      return
    }
    const tag: string = LibLoader.guid()
    this.queue[tag] = {
      callback,
    }
  }

  private handleCallback() {
    const queue: QUEUE = this.queue
    for (const key in queue) {
      if (Object.prototype.hasOwnProperty.call(queue, key)) {
        const request = queue[key]
        // 全部执行回调
        if (request) {
          request.callback()
          queue[key] = null
        }
      }
    }
  }
}
